import React from 'react';

const SavedProducts = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Saved Products</h1>
    <p>Your saved products and favorite suppliers will show here.</p>
  </div>
);

export default SavedProducts;
